// Library
import React, { useEffect, useState } from "react";

// Icons
import SendIcon from "@mui/icons-material/Send";

// CSS
import { ChatInput, SendButton } from "./ChatApp";
import { CircularProgress } from "@mui/material";
import { InvokePostServiceCall } from "../api/apiServices";
import { API } from "../constants/APIConstant";
import { ToastContainer, toast } from "react-toastify";

const HHPCConvo = (props) => {
  const {
    chat,
    setChat,
    setUserInput,
    setShowSpinner,
    setData,
    selectedProject,
    textOnly,
    inlineRef,
    setAllChatHistory = null,
    setHHPCAllChat,
    setPid = null,
    pid = null,
    isUseModel,
    languageModel,
    notify,
    addReport,
  } = props;
  const [message, setMessage] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const getHHPCData = async (resPid) => {
    try {
      const requestBody = {
        topic: message,
        vector_store: selectedProject,
        flag: textOnly ? "No" : "Yes",
        inline_ref: inlineRef ? "Yes" : "No",
        report: addReport ? "Yes" : "No",
        pid: resPid,
      };

      const useModelRequestBody = {
        model_name: languageModel,
        topic: message,
        // system_prompt: "You are a intellegent bot",
        pid: resPid,
      };

      let response = await InvokePostServiceCall(
        isUseModel
          ? API.DirectLLM_evidence_report
          : API.DynamicLLMFromDb_evidence_report,
        isUseModel ? useModelRequestBody : requestBody
      );

      setMessage("");
      if (!response.ok || !response.body) {
        throw response.statusText;
      }

      //logic to read data from stream
      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      let isImagesStarted = false;
      let isReferencesStarted = false;
      let referencesString = "";
      let imagesObj = "";
      let tempData = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) {
          // setLoading(false);
          break;
        }
        let decodedChunk = decoder.decode(value, { stream: true });

        if (decodedChunk.includes(`"status": "error"`)) {
          let responseError = JSON.parse(decodedChunk);
          const notify = () => toast.error(responseError.error_message);
          notify();
          decodedChunk = responseError.user_message;
        }

        // set isImagesStarted flag as true when stream starts sending images and tables JSON object.
        if (decodedChunk.includes(`{"images":`)) {
          isImagesStarted = true;
        }

        // set isReferencesStarted flag as true when stream starts sending References string.
        if (decodedChunk.includes("References:")) {
          isReferencesStarted = true;
          let tempStr = decodedChunk.split("References:");
          tempData += tempStr[0];
          decodedChunk = decodedChunk.replace(tempStr[0], "");
        }

        if (!isImagesStarted && !isReferencesStarted) {
          //when stream sends only text then this if block will execute
          tempData += decodedChunk;
          setData((prevValue) => {
            return `${prevValue}${decodedChunk}`;
          });
        } else if (!isImagesStarted && isReferencesStarted) {
          //when stream sends References then this if block will execute
          referencesString += decodedChunk;
        } else {
          //when stream sends images and table json then this block will execute
          imagesObj += decodedChunk;
        }
      }

      //parse the json data and create one final object which will have result, images, tables and references.
      let finalDataObject = imagesObj ? JSON.parse(imagesObj) : {};

      finalDataObject.tables?.forEach((table) => (table.isLoader = false));

      finalDataObject.tables?.forEach((table) => {
        table.isLoader = false;
        table.isShow = false;
        return table;
      });

      finalDataObject.images?.forEach((image) => (image.isShow = false));
      finalDataObject.result = tempData;
      finalDataObject.references = referencesString;

      setChat((prev) => [
        ...prev,
        {
          question: message,
          response: finalDataObject,
        },
      ]);
      if (chat.length === 0) {
        setAllChatHistory({
          question: message,
          response: finalDataObject,
          pid: resPid,
        });
      }
      setShowSpinner(false);
    } catch (error) {
      console.log("error: ", error);
      notify();
    } finally {
      setUserInput("");
      setBtnLoading(false);
      setData("");
    }
  };

  const handleHHPCSendClick = async () => {
    setUserInput(message);
    setBtnLoading(true);
    let resPid = await getPid();
    // setShowSpinner(true);
    getHHPCData(resPid);
  };

  const onInputKeyDown = (e) => {
    if (e.key === "Enter" && message.length > 0) {
      handleHHPCSendClick();
    }
  };

  const getPid = async () => {
    let resPid = pid;
    if (chat.length === 0) {
      const requestOptions = {
        method: "POST",
        body: "",
        redirect: "follow",
      };

      await InvokePostServiceCall(
        isUseModel ? API.DirectLLM_pid : API.HabilisGetAPI_pid,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          resPid = parseInt(result);
          setPid(resPid);
        })
        .catch((error) => {
          console.error(error);
          notify();
          return null;
        });
    }

    return resPid;
  };

  useEffect(() => {
    const requestBody = {
      project_name: selectedProject,
    };

    InvokePostServiceCall(
      isUseModel ? API.DirectLLM_get_history : API.DirectLLM_get_history,
      isUseModel ? {} : requestBody
    )
      .then((response) => response.text())
      .then((result) => {
        let historyDetails = JSON.parse(result);
        let tempArr = [];

        historyDetails.forEach((item) => {
          let projectAlreadyAdded = false;
          let projectIndex = "";

          let finalDataObject = {
            images: [],
            tables: item.table_ ? JSON.parse(item.table_) : null,
            result: item.response,
            references: item.reference,
          };
          for (let i = 0; i < tempArr.length; i++) {
            if (
              item.project_name === tempArr[i].project_name &&
              item.pid === tempArr[i].pid
            ) {
              projectAlreadyAdded = true;
              projectIndex = i;
              break;
            }
          }
          if (projectAlreadyAdded) {
            tempArr[projectIndex].chatList.push({
              executed_at: item.created_at,
              question: item.question,
              response: finalDataObject,
            });
          } else {
            tempArr.push({
              chatList: [
                {
                  executed_at: item.created_at,
                  question: item.question,
                  response: finalDataObject,
                },
              ],
              name: item.question,
              pid: item.pid,
              project_name: item.project_name,
            });
          }
          setHHPCAllChat(tempArr);
        });
      })
      .catch((error) => {
        console.error(error);
        notify();
      });
  }, []);

  return (
    <>
      <ToastContainer />
      <ChatInput className="evr-user-input">
        <input
          className="user-input w-100 h-100"
          type="text"
          placeholder="Type your query..."
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          onKeyDown={onInputKeyDown}
        />
        <SendButton
          disabled={btnLoading || message.length < 1}
          onClick={handleHHPCSendClick}
        >
          {!btnLoading ? (
            <SendIcon />
          ) : (
            <CircularProgress color="inherit" size={24} />
          )}
        </SendButton>
      </ChatInput>
    </>
  );
};

export default HHPCConvo;
